import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  content: {
    padding: 24,
  },
  title: {
    letterSpacing: '2px',
    textAlign: 'center',
    fontWeight: 650,
  },
  shareButton: {
    display: 'flex',
    margin: '10px',
  },
  copyButton: {
    margin: '0 6px 0 3px',
    backgroundColor: '#EFEFEF',
    '&:hover': {
      backgroundColor: '#E1E1E1',
    },
  },
  socialButton: {
    margin: '0 6px 0 6px',
  },
}))
